import { ImagePreview } from 'components/Image/ImagePreview';
import { CreativeBasic } from 'core/creative/Creative';
import styles from './productNativeCreativeDetail.module.scss';
import { get } from 'lodash';

export const WebRichProductNativeCreativeDetail: React.FC<{creative: Partial<CreativeBasic>}> = (props) => {
  const creativeValue = get(props.creative, 'creativeValue', get(props.creative, 'creativeValues'));
  if (!creativeValue) {
    return <div/>;
  }

  const imageUrl = get(creativeValue, 'images.0.imageUrl');
  if (!imageUrl) {
    return <div/>;
  }

  return (
    <div className={styles.productNativeCreativeDetailContainer}>
      <div className={styles.imageCreativeDetail} style={{ maxWidth: 'calc(100% - 250px)' }}>
        <ImagePreview
          border={false}
          url={imageUrl}
          config={{
            showName: false,
            showSize: false
          }}
        />
      </div>
    </div>
  );
};
